import { render, staticRenderFns } from "./c-board@.vue?vue&type=template&id=33a8c604&"
import script from "./c-board@.vue?vue&type=script&lang=ts&"
export * from "./c-board@.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports